//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './PromocodesClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';


export type RemovePromocodesQueryParameters = {
  keyword?: string | undefined ;
}

export type ApplyPromocodesQueryParameters = {
  keyword?: string | undefined ;
}

export function getAllUrl(): string {
  let url_ = getBaseUrl() + "/api/promocode";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getAllDefaultOptions: Omit<UseQueryOptions<Types.PromocodeDto[], unknown, Types.PromocodeDto[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PromocodeDto[], unknown, Types.PromocodeDto[]>, 'queryFn'>> = {
};
export function getGetAllDefaultOptions() {
  return getAllDefaultOptions;
};
export function setGetAllDefaultOptions(options: typeof getAllDefaultOptions) {
  getAllDefaultOptions = options;
}

export function getAllQueryKey(): QueryKey;
export function getAllQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'PromocodesClient',
      'getAll',
    ]);
}
export function __getAll(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getAll(
axiosConfig    );
}

/**
 * Returns all promocodes.
 */
export function useGetAllQuery<TSelectData = Types.PromocodeDto[], TError = unknown>(options?: Omit<UseQueryOptions<Types.PromocodeDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetAllQuery<TSelectData = Types.PromocodeDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PromocodeDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PromocodeDto[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getAll(context, axiosConfig) : __getAll,
    queryKey: getAllQueryKey(),
    ...getAllDefaultOptions as unknown as Omit<UseQueryOptions<Types.PromocodeDto[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Returns all promocodes.
 */
export function setGetAllData(queryClient: QueryClient, updater: (data: Types.PromocodeDto[] | undefined) => Types.PromocodeDto[], ) {
  queryClient.setQueryData(getAllQueryKey(),
    updater
  );
}

/**
 * Returns all promocodes.
 */
export function setGetAllDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PromocodeDto[] | undefined) => Types.PromocodeDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function createUrl(): string {
  let url_ = getBaseUrl() + "/api/promocode";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createMutationKey(): MutationKey {
  return trimArrayEnd([
      'PromocodesClient',
      'create',
    ]);
}

/**
 * Creates a new promocode.
 * @param dto Dto with data for creation.
 * @return Dto with Promocode data.
 */
export function useCreateMutation<TContext>(options?: Omit<UseMutationOptions<Types.PromocodeDto, unknown, Types.CreatePromocodeDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.PromocodeDto, unknown, Types.CreatePromocodeDto, TContext> {
  const key = createMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.CreatePromocodeDto) => Client.create(dto),
    mutationKey: key,
  });
}
  
export function removeUrl(keyword?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/promocode?";
if (keyword === null)
    throw new Error("The parameter 'keyword' cannot be null.");
else if (keyword !== undefined)
    url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removeMutationKey(keyword?: string | undefined): MutationKey {
  return trimArrayEnd([
      'PromocodesClient',
      'remove',
      keyword as any,
    ]);
}

/**
 * Removes a new promocode.
Can be removed only by user with SuperAdmin
 * @param keyword (optional) Keyword of Promocode
 */
export function useRemoveMutation<TContext>(keyword?: string | undefined, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = removeMutationKey(keyword);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.remove(keyword),
    mutationKey: key,
  });
}
  
type Remove__MutationParameters = RemovePromocodesQueryParameters

/**
 * Removes a new promocode.
Can be removed only by user with SuperAdmin
 * @param keyword (optional) Keyword of Promocode
 */
export function useRemoveMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, Remove__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: RemovePromocodesQueryParameters}): UseMutationResult<void, unknown, Remove__MutationParameters, TContext> {
  const key = removeMutationKey(options?.parameters?.keyword!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Remove__MutationParameters) => Client.remove(data.keyword ?? options?.parameters?.keyword!),
  mutationKey: key,
});
}
  
export function applyUrl(keyword?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/promocode/apply?";
if (keyword === null)
    throw new Error("The parameter 'keyword' cannot be null.");
else if (keyword !== undefined)
    url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function applyMutationKey(keyword?: string | undefined): MutationKey {
  return trimArrayEnd([
      'PromocodesClient',
      'apply',
      keyword as any,
    ]);
}

/**
 * Applies a promocode.
 * @param keyword (optional) Keyword of Promocode
 */
export function useApplyMutation<TContext>(keyword?: string | undefined, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = applyMutationKey(keyword);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.apply(keyword),
    mutationKey: key,
  });
}
  
type Apply__MutationParameters = ApplyPromocodesQueryParameters

/**
 * Applies a promocode.
 * @param keyword (optional) Keyword of Promocode
 */
export function useApplyMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, Apply__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: ApplyPromocodesQueryParameters}): UseMutationResult<void, unknown, Apply__MutationParameters, TContext> {
  const key = applyMutationKey(options?.parameters?.keyword!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Apply__MutationParameters) => Client.apply(data.keyword ?? options?.parameters?.keyword!),
  mutationKey: key,
});
}